const LOGS_BACKEND_URL = "https://logs.reclaimprotocol.org"
const APP_BACKEND_URL = "https://api.reclaimprotocol.org"
const ATTESTOR_NODE_URL = "wss://attestor.reclaimprotocol.org/ws"
const DEFAULT_EXPIRY_HOURS = 1;
const MAX_EXPIRY_HOURS = 72;



export { LOGS_BACKEND_URL, APP_BACKEND_URL, ATTESTOR_NODE_URL, DEFAULT_EXPIRY_HOURS, MAX_EXPIRY_HOURS }